export default "__VITE_ASSET__BlQPh9RM__"